var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex justify-content-center align-items-center logo-container"},[(_vm.placeholder || !_vm.imgSrc)?_c('img',{attrs:{"src":require("../../../assets/logo/placeholder.svg"),"height":_vm.imageHeight,"alt":"brand-logo"}}):_vm._e(),(_vm.imgSrc)?_c('div',{staticClass:"container"},[_c('img',{attrs:{"src":_vm.imgSrc}})]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }